import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { RoleWithMembers } from '@/lib/api/directory.client'

const STAFF_ROLES_VISIBLE = 2

/**
 * Compact read-only role chips for the Staff tab. The first
 * STAFF_ROLES_VISIBLE roles render as filled badges; any extra roles
 * collapse into a single `+N` outline badge with a tooltip listing them.
 */
export function StaffRolesCell({ roles }: { roles: RoleWithMembers[] }) {
  if (roles.length === 0) {
    return <span className="text-muted-foreground">—</span>
  }
  const visible = roles.slice(0, STAFF_ROLES_VISIBLE)
  const overflow = roles.slice(STAFF_ROLES_VISIBLE)
  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map(role => (
        <Badge key={role.id} variant="secondary" className="font-normal">
          {role.name}
        </Badge>
      ))}
      {overflow.length > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge variant="outline" className="font-normal cursor-default">
              +{overflow.length}
            </Badge>
          </TooltipTrigger>
          <TooltipContent>
            <div className="text-xs">
              {overflow.map(role => role.name).join(', ')}
            </div>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  )
}
